import { Component, Input, OnInit } from '@angular/core';
import { CustomerReviewRatingType } from 'anchor-shared/lib/model/enum/customer-review-rating-type';

const coreReviewTypeDetails = {
  [CustomerReviewRatingType.Cleanliness]: {
    name: 'Cleanliness',
    icon: '/prod/spray_bottle.svg',
  },
  [CustomerReviewRatingType.Amenities]: {
    name: 'Amenities',
    icon: '/prod/unicorn.svg',
  },
  [CustomerReviewRatingType.Accuracy]: {
    name: 'Accuracy',
    icon: '/prod/check_outline.svg',
  },
  [CustomerReviewRatingType.StaffPerformance]: {
    name: 'Captain/Crew',
    icon: '/prod/captain.svg',
  },
  [CustomerReviewRatingType.Location]: {
    name: 'Destinations',
    icon: '/prod/map.svg',
  },
  [CustomerReviewRatingType.Value]: {
    name: 'Value',
    icon: '/prod/tag.svg',
  },
};

@Component({
  selector: 'app-vessel-reviews-breakdown',
  templateUrl: './vessel-reviews-breakdown.component.html',
  styleUrls: ['./vessel-reviews-breakdown.component.scss'],
})
export class VesselReviewsBreakdownComponent implements OnInit {
  @Input() aggregateReviews;
  @Input() vesselReviews;
  @Input() verticalLayout: boolean = false;
  @Input() carousel: boolean = false;
  @Input() displayRatingCounts: boolean = true;

  coreReviews;
  coreReviewTypeDetails = coreReviewTypeDetails;
  coreReviewTypes = Object.keys(coreReviewTypeDetails);
  ratingCounts;

  constructor() {}

  ngOnInit(): void {
    this.coreReviews = (this.aggregateReviews || this.vesselReviews).reduce(
      (acc, curr) => {
        if (this.coreReviewTypes.includes(curr.ratingType)) {
          acc[curr.ratingType] = curr;
        }
        return acc;
      },
      {},
    );

    if (this.displayRatingCounts) {
      this.initRatingBar();
    }
  }

  initRatingBar() {
    this.ratingCounts = this.vesselReviews.reduce(
      (acc, curr) => {
        if (acc[curr.rating] == null) {
          acc[curr.rating] = 0;
        }

        acc[curr.rating] += 1;
        acc.total += 1;
        return acc;
      },
      { total: 0 },
    );
  }
}
